import React from 'react';
import { theme } from '@fiverr-private/theme';
import { L1_ICON_SIZES } from '../../constants';
import type { L1IconType } from '../../types';

const ImageL1Icon = ({ size = 'sm', color = 'currentColor' }: L1IconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={L1_ICON_SIZES[size]}
    height={L1_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 24 25"
  >
    <path d="M15.729 7.013a.996.996 0 0 0-.993 1c0 .553.445 1 .993 1h.015a.996.996 0 0 0 .992-1c0-.552-.444-1-.992-1z" />
    <path
      fillRule="evenodd"
      d="M4.537.835A4.417 4.417 0 0 0 .12 5.252v14.667a4.417 4.417 0 0 0 4.417 4.416h14.667a4.417 4.417 0 0 0 4.416-4.416V5.252A4.417 4.417 0 0 0 19.203.835zM2.474 3.19a2.92 2.92 0 0 1 2.063-.854h14.667a2.916 2.916 0 0 1 2.916 2.917v10.495l-2.486-2.487-.01-.01c-.673-.646-1.476-1.017-2.329-1.017s-1.656.37-2.328 1.017l-.01.01-.676.675-3.086-3.086-.01-.01c-.672-.646-1.475-1.017-2.328-1.017s-1.657.37-2.329 1.017l-.01.01-4.898 4.898V5.252c0-.774.307-1.516.854-2.063M13.76 15.536l2.402 2.402a.75.75 0 0 0 1.06-1.061l-1.88-1.88.67-.67c.445-.427.889-.594 1.283-.594s.838.167 1.283.593l3.542 3.542v2.05a2.916 2.916 0 0 1-2.917 2.917H4.537A2.917 2.917 0 0 1 1.62 19.92v-2.05l5.953-5.954c.445-.426.89-.593 1.284-.593s.838.167 1.283.593l3.602 3.602.009.01z"
      clipRule="evenodd"
    />
  </svg>
);
ImageL1Icon.displayName = 'ImageL1Icon';
export default ImageL1Icon;
